/* global axios */
import ApiClient from './ApiClient';

class FollowUpCadenceAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/follow_up_cadence`);
  }

  stop(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/follow_up_cadence`);
  }
}

export default new FollowUpCadenceAPI();
